import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'

window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('live_shopping')) return

  const stepSwiper = new Swiper('.step-swiper', {
    modules: [Autoplay, Navigation, Pagination],
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    effect: 'slide',
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      slideChange: function () {
        const activeIndex = this.realIndex
        const texts = document.querySelectorAll('.text_wrapper .text')

        // 対応するテキストの切り替え
        texts.forEach((el, i) => {
          el.classList.toggle('is-active', i === activeIndex)
        })

        // アクティブ以前のスライドに .is-before クラスを付与
        this.slides.forEach((slide, i) => {
          if (i < this.activeIndex) {
            slide.classList.add('is-before')
          } else {
            slide.classList.remove('is-before')
          }
        })
      },
    },
  })

  // 初期表示時のテキストに .is-active を付与
  const firstText = document.querySelector('.text_wrapper .text')
  if (firstText) firstText.classList.add('is-active')

  // 初期表示時にも .is-before を反映
  stepSwiper.slides.forEach((slide, i) => {
    if (i < stepSwiper.activeIndex) {
      slide.classList.add('is-before')
    }
  })
})
